import { useState, useEffect } from 'react';

const useUserCountry = () => {
  const [countryCode, setCountryCode] = useState(null);

  useEffect(() => {
    const storedCountryCode = localStorage.getItem('userCountryCode');

    if (storedCountryCode) {
      setCountryCode(storedCountryCode);
    } else {
      fetch('https://api.country.is/')
        .then(response => response.json())
        .then(data => {
          const fetchedCountryCode = data.country;
          setCountryCode(fetchedCountryCode);
          localStorage.setItem('userCountryCode', fetchedCountryCode);
        })
        .catch(error => {
          console.error("Error fetching country data:", error);
        });
    }
  }, []);

  return countryCode;
};

export default useUserCountry;